import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appcents'
})
export class AppCentsPipe implements PipeTransform {

  transform(
    value: number
  ): string | null {
    const str = value.toFixed(2);
    return str.substring(str.indexOf('.'));
  }
}
